"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreKey = void 0;
exports.StoreKey = {
    User: 'dvc:user',
    AnonUserId: 'dvc:anonymous_user_id',
    AnonymousConfig: 'dvc:anonymous_config',
    IdentifiedConfig: 'dvc:identified_config',
};
//# sourceMappingURL=types.js.map